export default {
	install(Vue, { sectionName = '카페탑', pageName = '인기글뷰' } = {}) {
		const prefix = `${sectionName}>${pageName}`;

		const isDefined = () => typeof TiaraTracker !== 'undefined';

		const generateProps = (custom = {}) => {
			return {...custom}
		};

		Vue.prototype.$trackEvent = ({ layer, desc, url = '', customProps, eventMeta, actionKind }) => {
			if (!isDefined()) return;
			const { layer1='', layer2='', layer3='' } = layer;
			const tracker = TiaraTracker.getInstance()
				.trackEvent(`${prefix}>${desc}`)
				.click({
					layer1: layer1,
					layer2: layer2,
					layer3: layer3,
					click_url: url.slice(0, 255),
					copy: '',
					posx: 0,
					posy: 0
				})
				if(actionKind)
					tracker.actionKind(actionKind)
				if(customProps)
					tracker.customProps(generateProps(customProps))
				if(eventMeta)
					tracker.eventMeta(eventMeta)

				tracker.track();
		};

		Vue.prototype.$trackViewImp = ({ page, pageName: vPageName, layerName, contents, customProps = {} }) => {
			if (!isDefined() || !contents.length) return;
			TiaraTracker.getInstance()
				.setSection('user_action')
				.setPage(page)
				.trackViewImp(`유저액션_${vPageName}_${layerName}`)
				.viewImpContents(contents)
				.customProps(generateProps(customProps))
				.track();
		};
	}
}
